var paragraph_default = {
  "fontElementMap": "xlkfL",
  "elementSpacing": "AAhDr",
  "text": "g6N-7 AAhDr",
  "child": "drYmy"
};
export {
  paragraph_default as default
};
//# sourceMappingURL=paragraph-scss.js.map
